import Landing from '../components/Landing';

export default Landing;
